import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import DishCard from './DishCard.jsx';

import * as ApiCall from '../ApiCall.jsx';

//a drop down menu titles with the category name
// when expanded lists all the dishes within the category, clicking a dish takes you to its page
export default function CategoryMenu({categoryInfo}) {

  const navigate = useNavigate();

  const [state, setState] = React.useState('loading');
  const [dishes, setDishes] = React.useState([]);

  function addDish(dish) {
    let copy = dishes;
    copy.push(dish);
    setDishes(copy);
  }


  React.useEffect(() => {
    setState("loading");
    ApiCall.get('/menu/dishes/'+ categoryInfo.position)
    .then((dishes) => {
      for (let i = 0; i < dishes.length; i++) {
        addDish(dishes[i]);
      }
      setState("success");
    })
    .catch((msg) => {alert("Failed to get dishes: "+msg)}); 
  }, [])

  return (
    <Accordion sx={{backgroundColor: "#e6e6e6",
      '&.Mui-expanded': {
        m: 0
    }}}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={categoryInfo.name}
              id={categoryInfo.id}
              sx={{ backgroundColor: "white", fontWeight: "bold" }}
            >
              { categoryInfo.name }
            </AccordionSummary>
            <AccordionDetails>
              { (state === "loading") &&
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <CircularProgress />
                </Box>
              }
              { (state === "success") &&
                <List>
                  {
                    dishes.map((dish) => (
                      <ListItem disablePadding key={dish.id}>
                        <DishCard key={dish.id} dishInfo={dish} categoryName={categoryInfo.name}></DishCard>
                      </ListItem>
                    ))
                  }
                </List>
              }
            </AccordionDetails>
          </Accordion>
  )
}